export default __webpack_public_path__ + "static/media/m8.29a20be1.png";